<router-outlet></router-outlet>
<ng-progress #loader></ng-progress>